<div id="sidebar-nav-container" [class.open]="isSidebarOpen" [class.pinned]="isPinned" [class.show-mobile-menu]="showMobileMenu">
  <div id="sidebar-content-wrapper">
    <div id="sidebar-pin"
      [class.open]="isSidebarOpen"
      [class.pinned]="isPinned" (click)="toggleSidebarPin()"
      [class.prevent-pinned]="isSmallDesktop"
      [pTooltip]="pinTooltip"
      tooltipPosition="right"
      appendTo="body">
      <ic-icon-svg [iconName]="'thumbtack'" class="pin-icon"></ic-icon-svg>
    </div>

    <div id="sidebar-header">
      @if (user?.isToroUser()) {
        <div id="sb-acct-select-wrapper">
          <ic-toolbar-admin-account (adminDashboardClicked)="onAdminDashboardClicked()" (accountDetailsClicked)="onAdminAccountDetailsClicked()"></ic-toolbar-admin-account>
        </div>
      } @else {
        <div id="sb-acct-select-wrapper">
          <ic-toolbar-account-select
            [user]="user"
            (selectionMade)="onAccountSelectionMade($event)"
          ></ic-toolbar-account-select>
        </div>
      }
    </div>

    <div id="sidebar-content-container">
      <div #scrollDiv id="sidebar-content" icScrollbar="dark">
        <p-accordion
          [class]="'ic-sn-acc' + (isSidebarOpen ? ' open' : '')"
          [multiple]="false"
          [value]="activeIndex"
          (valueChange)="onActiveIndexChange($event)"
          (onClose)="onTabClose($event)"
          >
          @for (item of navItems; track item.label; let i = $index) {
            <p-accordion-panel [value]="i"
              >
              <p-accordion-header>
                <!-- The design supplies its own expand icons; hide the built-in chevron. -->
                <ng-template #toggleicon></ng-template>
                @if (!showOpenLayout) {
                  <div
                    class="ic-sn-1x1-item icon-wrap"
                    [class.is-mobile]="showMobileMenu" [class.active]="item.isActiveTab === true"
                    [pTooltip]="item.label | translate" tooltipPosition="right" appendTo="body" tooltipStyleClass="menu-tooltip"
                    >
                    <ic-menu-icons [iconName]="item.icon" class="icon-svg"></ic-menu-icons>
                  </div>
                }
                @if (showOpenLayout) {
                  <div
                    class="nt-flex nt-flex-space-bw nt-w-100 nt-align-items-center nav-item"
                    [class.active]="!item.children.length && item.isActiveTab === true" [class.active-tab]="!!item.children.length && item.isActiveTab === true"
                    >
                    <div class="ic-sn-header-text">
                      <div class="ic-sn-item-icon icon-wrap">
                        <ic-menu-icons [iconName]="item.icon" class="icon-svg"></ic-menu-icons>
                      </div>
                      <span>{{ $safeNavigationMigration(item?.label) | translate }}</span>
                    </div>
                    @if (item.children && item.children.length > 0) {
                      <div class="ic-sn-nav-icon">
                        <img [src]="imagePathRoot + (activeIndex == i ? '/sn-close-acc.png' : '/sn-open-acc.png')" alt="">
                      </div>
                    }
                  </div>
                }
              </p-accordion-header>
              <p-accordion-content>
                @if (item.children && item.children.length > 0) {
                  <div id="ic-sn-item-body">
                    @for (child1 of item.children; track child1.label) {
                      <div>
                        <div class="ic-sn-item-child child1 nav-item"
                          [class.is-selectable]="child1.onClick != null" [class.active]="child1.routerLink != null && child1.routerLink == activeRoute"
                          (click)="child1.onClick != null ? child1.onClick(child1) : null"
                          >
                          <span class="prevent-select">{{ child1.label | translate }}</span>
                        </div>
                        @for (child2 of child1.children; track child2.label) {
                          <div
                            class="ic-sn-item-child child2 is-selectable nav-item"
                            [class.active]="child2.routerLink != null && child2.routerLink == activeRoute"
                            (click)="child2.onClick != null ? child2.onClick(child2) : null"
                            >
                            <span class="prevent-select">{{ child2.label | translate }}</span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>

      </div>
    </div>

    <div id="sidebar-footer" [class.open]="showOpenLayout" [class.pinned]="isPinned" (click)="toggleSidebarOpen()">
      <div id="sidebar-footer-content" class="prevent-select">
        <ic-menu-icons [iconName]="'arrow-export'" class="footer-icon-wrap"></ic-menu-icons>
        <span id="footer-text" class="prevent-select nt-uppercase">{{ 'MENUS.HIDE_MENU' | translate }}</span>
      </div>
    </div>

  </div>
</div>
